import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import Gallery from '../components/Gallery';
import TitleWithLanterns from '../components/TitleWithLanterns';
import Logo from '../components/Logo';

const GalleryPage: React.FC = () => {
  const { t } = useTranslation();

  const galleryItems = [
    // Real restaurant photos
    { src: '/restaurant_photos/photo1.webp', alt: 'Elegant dining room with luxury decor and chandeliers', type: 'image' as const },
    { src: '/restaurant_photos/photo2.webp', alt: 'Extensive buffet area with diverse international cuisine', type: 'image' as const },
    { src: '/restaurant_photos/photo3.webp', alt: 'Modern buffet setup with elegant lighting and glass displays', type: 'image' as const },
    { src: '/restaurant_photos/photo4.webp', alt: 'Premium buffet display with gourmet food options', type: 'image' as const },
    { src: '/restaurant_photos/photo5.webp', alt: 'Fresh dessert and fruit station with colorful presentations', type: 'image' as const },
    { src: '/restaurant_photos/photo6.webp', alt: 'Authentic sushi and Japanese cuisine section', type: 'image' as const },
    { src: '/restaurant_photos/photo7.webp', alt: 'International buffet with copper warming lamps', type: 'image' as const },
    { src: '/restaurant_photos/photo8.webp', alt: 'Fresh sashimi and seafood display with premium fish', type: 'image' as const },
    { src: '/restaurant_photos/photo9.webp', alt: 'Complete buffet overview with central dining area', type: 'image' as const },
    { src: '/restaurant_photos/photo10.webp', alt: 'Fresh oysters and seafood on ice display', type: 'image' as const },
    { src: '/restaurant_photos/photo11.webp', alt: 'Premium seafood selection with crabs and oysters', type: 'image' as const },
    { src: '/restaurant_photos/photo12.webp', alt: 'Spacious dining area with Asian-inspired decor', type: 'image' as const },
    { src: '/restaurant_photos/photo13.webp', alt: 'Professional restaurant staff team at the bar area', type: 'image' as const },
  ];

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative h-[50vh] flex items-center justify-center overflow-hidden bg-white">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-80"
          style={{
            backgroundImage: 'url(/gallery-hero-new.png)',
          }}
        />
        <div className="absolute inset-0 bg-luxury-gradient" />
        
        {/* Smooth transition gradient to white */}
        <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white via-white/60 to-transparent" />
        
        <TitleWithLanterns 
          title={t('gallery.pageTitle', 'Notre Univers en Images')}
          subtitle="Galerie"
          lanternType={4}
        />
      </section>

      <Gallery items={galleryItems} />
    </div>
  );
};

export default GalleryPage;